import { render, staticRenderFns } from "./EmerInvestigation.vue?vue&type=template&id=075ce21b&scoped=true"
import script from "./EmerInvestigation.vue?vue&type=script&lang=js"
export * from "./EmerInvestigation.vue?vue&type=script&lang=js"
import style0 from "./EmerInvestigation.vue?vue&type=style&index=0&id=075ce21b&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075ce21b",
  null
  
)

export default component.exports